export enum Sex {
    man = 'man',
    women = 'women',
}
